import { render, staticRenderFns } from "./AuthSSO.vue?vue&type=template&id=81137aec"
import script from "./AuthSSO.vue?vue&type=script&lang=js"
export * from "./AuthSSO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports